import { Chip } from '@mui/material';
import { styled } from '@mui/system';

// The card's own chip shape, shared by the tags row's add button and the
// expand panel's related-item links.
const ItemTagChip = styled(Chip)(() => ({
  color: '#1a1a1a',
  border: '1px solid #d1d5db',
  borderRadius: 999,
  fontSize: 11,
  letterSpacing: '0.3px',
  textTransform: 'lowercase',
  height: 'auto',
  background: '#fff',
  flexShrink: 0,
  '& .MuiChip-label': {
    padding: '2px 9px',
  },
}));

export default ItemTagChip;
